import { Base } from "../core/base.model";



export class ConfiguracionBean extends Base{
      id: number;
      id_Servidor: number;
      id_Usuario: number;
      id_Aplicacion: number;
      id_corporativo: number;
}